import { create, filter, findAll, findOne, update } from "@/store/Crud/functions/actions";
import { SET_NEXT_APPOINTMENT } from "./types";
export const setNextAppointment = (store, appointment) => {
    store.commit(SET_NEXT_APPOINTMENT, appointment);
};
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    setNextAppointment,
};
